import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { getDealQuery } from '@dealstack/frontend/shared/dataExchange/services/project.service.ts';

interface Params {
	dealId: string;
	mipId: string;
}

/**
 * Programme (MIP) data as its own query. It shares the deal cache entry (same query
 * key as DealContext's deal query) but selects the single programme, so consumers
 * only re-render when their programme changes and freshness is handled declaratively
 * (refetch-on-mount when stale) instead of an imperative refetchDealData() on mount.
 * Invalidate via the `DEAL_DEALID_GET` query key.
 */
export const useMipData = ({ dealId, mipId }: Params) =>
	useQuery({
		queryKey: [formatUnicorn(API_PATHS.DEAL_DEALID_GET, { dealId })],
		queryFn: ({ signal }) =>
			getDealQuery(formatUnicorn(API_PATHS.DEAL_DEALID_GET, { dealId }), signal),
		placeholderData: keepPreviousData,
		select: (deal) => deal?.mips?.find(({ id }) => id === mipId),
	});
